import { render, staticRenderFns } from "./create-ticket-button.vue?vue&type=template&id=1a2c611c"
import script from "./create-ticket-button.vue?vue&type=script&lang=js"
export * from "./create-ticket-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports